import { useMemo } from 'react';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
import { useComponent } from '../state/ComponentContext';
import { useConfigentoStoreRef } from '../state/StoreContext';
import { useRuleResults } from '../rules/RuleResultsContext';
import { useEvaluatedMap } from '../eval/EvalContext';
import { useTranslation } from '../i18n';
import { buildAssetPayload } from '../api/assetPayload';

/**
 * The combined SKU of the current configuration, built from the order
 * payload so it matches what the shop receives. Labels play no part in it,
 * so the content locale does not matter here.
 */
export function useCombinedSku(): string {
    const component = useComponent();
    const store = useConfigentoStoreRef();
    const selections = useStore(store, useShallow((s) => s.selections));
    const evaluated = useEvaluatedMap();
    const { hiddenCharacteristics } = useRuleResults();
    const { locale: uiLocale } = useTranslation();

    return useMemo(
        () => buildAssetPayload({
            component,
            selections,
            evaluated,
            locale: undefined,
            uiLocale,
            hiddenCharacteristics,
        })._combined_sku ?? '',
        [component, selections, evaluated, uiLocale, hiddenCharacteristics],
    );
}
